<!--<sub>Setting</sub>-->
<div >

 {{line.variable.text}}

 {{GetValue(itemValue) }}

 <app-unit class="col-auto"  [unit]="line.variable.unit"></app-unit>

</div>





